import { useField } from 'formik';
import React from 'react';

// PROPS Optional
// secondlabel -> if you want put other label on side the primary label
// icon -> if you want put icon in input
// clickicon -> if you want icon to be able to click

const InputText = ({ label, required, disabled, ...props }) => {
  const [field, meta] = useField(props);
  const errorClass =
    'block w-full rounded-xl border-0 py-1.5 shadow-sm text-red-900 ring-1 ring-inset ring-red-300 placeholder:text-red-300 focus:ring-2 focus:ring-inset focus:ring-red-500 text-sm';
  const classInput =
    'block w-full rounded-xl border-0 py-1.5 shadow-sm text-kin-text font-regular ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-main text-sm disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:ring-gray-200';
  const disabledClassInput =
    'block w-full rounded-xl border-0 py-1.5 shadow-sm text-sm font-regular cursor-not-allowed bg-gray-100 text-gray-500 ring-1 ring-inset ring-gray-200 placeholder:text-gray-400';
  const labelClass = `block text-sm font-medium leading-6 ${
    disabled ? 'text-kin-text' : 'text-kin-text'
  }`;
  const requiredClass = `block text-xs font-light leading-6 ${
    disabled ? 'text-gray-300' : 'text-gray-400'
  }`;
  const secondLabelClass = disabled ? 'text-gray-400' : '';
  const iconClass = `absolute inset-y-0 right-0 flex items-center pr-3 ${
    disabled ? 'text-gray-400' : ''
  }`;
  const inputClassName = disabled ? disabledClassInput : meta.error ? errorClass : classInput;

  if (props.icon) {
    const passInputProps = {
      name: props.name,
      type: props.type,
    };
    return (
      <div>
        <div className="flex items-center justify-between">
          <div className="flex items-center justify-between gap-1">
            <label className={labelClass}>{label}</label>
            {required && <label className={requiredClass}>{`(required)`}</label>}
          </div>
          {props.secondlabel ? <div className={secondLabelClass}>{props.secondlabel}</div> : <></>}
        </div>

        <div className="relative mt-1">
          <input
            disabled={disabled}
            className={`${inputClassName} pr-10`}
            {...field}
            {...passInputProps}
          />
          {props.clickicon && !disabled ? (
            <div onClick={props.clickicon} className={iconClass}>
              {props.icon}
            </div>
          ) : (
            <div className={iconClass}>{props.icon}</div>
          )}
        </div>
        {!disabled && meta.touched && meta.error ? (
          <div className="text-red-600 mt-1 text-sm">{meta.error}</div>
        ) : null}
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-between">
        <div className="flex items-center justify-between gap-1">
          <label className={labelClass}>{label}</label>
          {required && <label className={requiredClass}>{`(required)`}</label>}
        </div>
        {props.secondlabel ? <div className={secondLabelClass}>{props.secondlabel}</div> : <></>}
      </div>
      <div className="mt-1">
        <input disabled={disabled} className={inputClassName} {...field} {...props} />
      </div>
      {!disabled && meta.touched && meta.error ? (
        <div className="text-red-600 mt-1 text-sm">{meta.error}</div>
      ) : null}
    </div>
  );
};

export default InputText;
